import { useMemo } from 'react';
import { type CampaignInfoType, useHasMany, useIsHeaderCollapsed, useCampaignTypeById } from 'features/campaigns';
import { useCampaignInfoDisplay } from '../../../../hooks/info/useCampaignInfoDisplay';
import CampaignFinishedState from './ui/CampaignFinishedState';
import CampaignInfoList from './CampaignInfoList';

interface CampaignInfoDisplayProps {
  infoTypes: CampaignInfoType[];
  campaignId?: string;
}

const CampaignInfoDisplay: React.FC<CampaignInfoDisplayProps> = ({ infoTypes, campaignId }) => {
  const { getSelectedInfoItems, getCampaignInfoStyles, isFinished } = useCampaignInfoDisplay(campaignId);
  const selectedInfoItems = useMemo(() => getSelectedInfoItems(infoTypes), [getSelectedInfoItems, infoTypes]);
  const isCollapsed = useIsHeaderCollapsed();
  const campaignType = useCampaignTypeById(campaignId);
  const hasMany = useHasMany(campaignType);

  const campaignInfoDisplayStyles = useMemo(() => getCampaignInfoStyles(), [getCampaignInfoStyles]);

  if (isFinished && !isCollapsed) {
    return <CampaignFinishedState campaignId={campaignId} styles={campaignInfoDisplayStyles} />;
  }

  return <CampaignInfoList items={selectedInfoItems} campaignId={campaignId} hasMany={hasMany} />;
};

export default CampaignInfoDisplay;
